<template>
  <div class="p-4">
    <div class="text-lg text-white font-bold">
      {{ $t('frontend_sites_baselayout_groovefunnels_help_make_best_plaform') }}
    </div>

    <div class="text-grey-500 pt-2 pb-4">
      {{ $t('frontend_feedback_message') }}
    </div>

    <div class="text-white pt-3">
      <a @click="routeToRoadmap" class="cursor-pointer">{{
        capitalizeFirstLetter($t('frontend_sites_baselayout_roadmap'))
      }}</a>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      currentApp: 'groovepages',
    };
  },
  created() {
    // Finding app from the url
    if (window.location.href.indexOf('/groovesell/') > -1) {
      this.currentApp = 'groovesell';
    } else if (window.location.href.indexOf('/groovemail/') > -1) {
      this.currentApp = 'groovemail';
    } else if (window.location.href.indexOf('/groovevideo/') > -1) {
      this.currentApp = 'groovevideo';
    } else if (window.location.href.indexOf('/groovemember/') > -1) {
      this.currentApp = 'groovemember';
    }
  },
  methods: {
    capitalizeFirstLetter(str) {
      return str
        .split(' ')
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
    },
    routeToRoadmap() {
      window.location.replace(`https://app.groove.cm/#/roadmap`);
    },
  },
};
</script>
